module.exports = __webpack_public_path__ + "static/media/Gwangjang Translated by J_Lee_77777.7b5ea9d7.md";